const UnAuthorized = () => {
    return (
        <>
            <h1>Un Authorized</h1>
        </>
    )
}

export default UnAuthorized;